import { X } from "lucide-react";
import * as React from "react";
import { cn } from "../../lib/utils";
import { Button } from "./button";

export interface FilterChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  label: string;
  value?: React.ReactNode;
  onRemove: () => void;
  removeLabel?: string;
  disabled?: boolean;
}

export const FilterChip = React.forwardRef<HTMLSpanElement, FilterChipProps>(
  (
    {
      className,
      label,
      value,
      onRemove,
      removeLabel = `Remove ${label} filter`,
      disabled = false,
      ...props
    },
    ref
  ) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex h-7 items-center gap-1 rounded-md border border-accent bg-accent-soft pl-2 text-[11px] text-accent transition-colors duration-150",
        className
      )}
      {...props}
    >
      <span className="font-medium">{label}</span>
      {value !== undefined && value !== null ? (
        <span className="text-foreground">{value}</span>
      ) : null}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label={removeLabel}
        disabled={disabled}
        className="h-6 w-6 rounded-sm text-accent hover:bg-accent hover:text-accent-foreground"
        onClick={onRemove}
      >
        <X className="h-3 w-3" aria-hidden="true" />
      </Button>
    </span>
  )
);

FilterChip.displayName = "FilterChip";
